import { memo } from 'react';
import PropTypes from 'prop-types';

import { STEPS } from '../constants';
import Day from './Day';
import Hour from './Hour';
import Minute from './Minute';
import NoSchedule from './NoSchedule';

import { Case, Default, Switch } from 'react-if';

import './Body.scss';

const Body = ({ activeStep = undefined, dayOfMonth = "", dayOfWeek = "", hour = "", minute = "", setDayOfMonth, setDayOfWeek, setHour, setMinute }) => (
  <div className="cron-creator__body">
    <Switch>
      <Case condition={activeStep === STEPS.HOUR}>
        {() => (
          <Hour
              hour={hour}
              setHour={setHour}
          />
        )}
      </Case>
      <Case condition={activeStep === STEPS.MINUTE}>
        {() => (
          <Minute
              minute={minute}
              setMinute={setMinute}
          />
        )}
      </Case>
      <Case condition={activeStep === STEPS.DAY}>
        {() => (
          <Day
              dayOfMonth={dayOfMonth}
              dayOfWeek={dayOfWeek}
              setDayOfMonth={setDayOfMonth}
              setDayOfWeek={setDayOfWeek}
          />
        )}
      </Case>
      <Default>
        {() => (
          <NoSchedule/>
        )}
      </Default>
    </Switch>
  </div>
)

Body.propTypes = {
  activeStep: PropTypes.string,
  dayOfMonth: PropTypes.string,
  dayOfWeek: PropTypes.string,
  hour: PropTypes.string,
  minute: PropTypes.string,
  setDayOfMonth: PropTypes.func.isRequired,
  setDayOfWeek: PropTypes.func.isRequired,
  setHour: PropTypes.func.isRequired,
  setMinute: PropTypes.func.isRequired,
}

export default memo(Body)